import { styled } from '@mui/material'
import { SxProps, Theme } from '@mui/system'
import React from 'react'

const Span = styled('span')``
interface MaterialSymbolProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  children: string | React.ReactNode | React.ReactNode[]
  variant?: 'outlined' | 'fill'
  sx?: SxProps<Theme>
}
export const MaterialSymbol: React.FC<MaterialSymbolProps> = ({
  children,
  variant = 'outlined',
  sx,
  ...props
}) => {
  return (
    <Span sx={sx} className={`material-symbols-${variant}`} aria-hidden='true' {...props}>
      {children}
    </Span>
  )
}

export default MaterialSymbol
